import { GlobalHealthSystem } from "../healthSystem/global-health-system";
import { PhysicianPractice } from "../practitioner/physicianPractice";

export class PhysicianHeader {

    constructor(physician: PhysicianPractice, healthSystem: GlobalHealthSystem){
        this.selectedPhysician = physician;
        this.selectedHealthSystem = healthSystem
    }

    selectedPhysician: PhysicianPractice;
    selectedHealthSystem: GlobalHealthSystem;
}